/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const SeedlingSolidV6 = (props) => (
  <Icon {...props} name="Seedling Solid V6">
    <path d="M2 2.972H0c0 3.869 3.134 7 7 7v4C7 14.55 7.45 15 7.972 15S9 14.55 9 14v-4c0-3.866-3.134-7.028-7-7.028zM14 1a6.998 6.998 0 0 0-6.119 3.603 7.969 7.969 0 0 1 1.844 3.359A7.003 7.003 0 0 0 16 .999h-2z" />
  </Icon>
);

export default SeedlingSolidV6;
